import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styleSheet/ios-fixes.css"; // iOS Safari specific fixes
import "./i18n"; // Initialize i18n
import App from "./App";
import { AuthProvider, API_URL } from "./AuthContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// React Router
import { BrowserRouter } from "react-router-dom";

// Tworzymy motyw Material UI
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#ff9900",
    },
    secondary: {
      main: "#e58e00",
    },
    background: {
      default: "#171717",
      paper: "#212121",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    {/* <React.StrictMode> */}
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
    {/* </React.StrictMode> */}
  </BrowserRouter>,
);
